import { isClient } from "../../../utils/ssr";
import styles from "./styles.module.scss";
import { UsersTypeEnum } from "@monta/utils";

export interface IShop {
  id: number;
  title: string;
  link: string[];
}

const shopItems: IShop[] = [
  {
    id: UsersTypeEnum.STUDENT,
    title: "دانش آموزان",
    link: ["/"],
  },
  {
    id: UsersTypeEnum.TEACHER,
    title: "دبیران",
    link: ["/teacher"],
  },
  {
    id: UsersTypeEnum.DEAN,
    title: "مدارس / مشاوران",
    link: ["/school"],
  },
];

const ShopNav = () => {
  const shops = () => {
    const items: IShop[] = [];
    if (isClient()) {
      shopItems.forEach((item) => {
        item.link.forEach((link) => {
          if (!window.location.pathname.includes(link)) items.push(item);
        });
      });
    }
    return items;
  };

  return (
    <nav className={styles["shopNav"]}>
      <ul className={styles["shopNav__list"]}>
        {shops().map((shop) => (
          <li className={styles["shopNav__list-item"]} key={shop.id}>
            <a href={shop.link[0]}>
              <span className={styles["shopNav__list-item__sub"]}> برای </span>
              {shop.title}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ShopNav;
